export default "__VITE_ASSET__CKmtfeuh__"